import { jsx as _jsx } from "react/jsx-runtime";
import { MediaFill } from '../../atoms/media-fill/media-fill';
import { billboardHeroMock } from '../billboard-hero/mock';
export const splitHeroMedia = {
    image: _jsx("img", { src: "https://placehold.co/1200x1300", alt: "", loading: "eager" }),
};
export const splitHeroMock = {
    media: _jsx(MediaFill, { media: splitHeroMedia }),
    title: 'The business expense card built for clarity',
    description: 'Easily control business expenses in 50+ currencies, with bank-level security and cashback on all card spend',
    cta: {
        label: 'Start your trial',
        href: '/start-trial',
    },
    logoRow: {
        caption: billboardHeroMock.logoRow.caption,
        logos: billboardHeroMock.logoRow.logos,
    },
};
